import { render } from "./exerciseLeft.vue?vue&type=template&id=f75d9b62&scoped=true"
import script from "./exerciseLeft.vue?vue&type=script&lang=js"
export * from "./exerciseLeft.vue?vue&type=script&lang=js"

import "./exerciseLeft.vue?vue&type=style&index=0&id=f75d9b62&lang=scss&scoped=true"

import exportComponent from "/root/workspace/interactive-system-pc_dBxe/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f75d9b62"]])

export default __exports__